jQuery(document).ready(function($){
  $('.my-dashboard-section .left-navigation a').not('.logout').click(function(e){
    e.preventDefault()
    $(this).addClass('active').siblings().removeClass('active')
    var selector_content = $(this).attr('href')
    $('.my-dashboard-section .dashboard-content .tab-pane').removeClass('active')
    $(selector_content).addClass('active')
  })
  $('.my-dashboard-section .left-navigation a.logout').click(function(){
  	$(this).addClass('active').siblings().removeClass('active')
  })
  
  $('.edit_address').click(function(){
  	$(this).parent().siblings('.edit-address').slideToggle()
  })
  
  var location = window.location.hash;
  
  $(location).show()
  
  if(location == ''){
  	$('#AddAddress').show()
  }
})